
//45
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "Slider2262726817",
    {"root":"Slider2262726817--root","tooltip":"Slider2262726817--tooltip","track":"Slider2262726817--track","inner":"Slider2262726817--inner","trackFill":"Slider2262726817--trackFill","thumb":"Slider2262726817--thumb","thumbShape":"Slider2262726817--thumbShape","tick":"Slider2262726817--tick","tickLineWidth":"1px","tickLineHeight":"10px","tickDotSize":"3px","tickMarksGap":"12px","tooltipGap":"10px"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/slider/Slider.st.css
// module id = 1282
// module chunks = 0